// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3335":"62747a40","6288":"67b5170b"}[chunkId] + ".chunk.css";
};